import React from "react";
import { NavLink } from "react-router-dom";
// used for making the prop types of this component
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// reactstrap components
import { Nav, Collapse, Button } from "reactstrap";
// core components
import logo from "assets/img/df.png";
import { getCurrentUser } from '../../services/AuthService'
import { tenantExclude, platformAdminInclude, generalUserInclude } from "settings/shared/constants";
import { MenuNames } from "settings/shared/constants";
import WidgetLayout from "views/WidgetLayout/Widgets";
import routes from "../../../src/routes";
import SettingsService from "../../services/api/Setting";
import { APIRESPONSE } from "settings/shared/constants";
import { toast } from "react-toastify";
import PowerBI from "views/Powerbi/PowerBI";

var ps;
const styles = {
  navStyle:{
    display:'list-item',
  },
   disablelink:{
  pointerEvents: 'none',
  cursor:'default',
  paddingLeft: '20px',
},
displaynone:{
  pointerEvents: 'pointer',
  cursor:'default',
  display:'none',
  opacity: '0.0'
},
dropdownaligin:{
  // marginLeft:'20px',
  pointerEvents: 'pointer',
  paddingLeft: '10px',
},
dropdownaligin_bill:{
  // marginLeft:'22px',
  pointerEvents: 'pointer',
  paddingLeft: '10px',
},
disablesubmenu:{
  pointerEvents: 'none',
  cursor:'default',
},
submenumini:{
  marginLeft: '8px',
  color:'black'
}
}

class Sidebar extends React.Component {
  state = {
      userRole:true
  };
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      isAuthenticated: false, profile: '',
      sidebarHover : false,
      isScreen: window.innerWidth < 1024,
      ...this.getCollapseStates(props.routes),
      tempArray: [],
      customMenuLists: []
    };
    this.sidebar = React.createRef();
  }
  componentDidMount() {
       this.getCustomMenus();
       if(!localStorage.getItem('UserProfile')) {
      getCurrentUser()
      .then(response => {
        localStorage.setItem("UserProfile",JSON.stringify(response));
        this.setState({
          isAuthenticated: true,
          profile: JSON.parse(localStorage.getItem('UserProfile'))
          
        });
        let myProfile = JSON.parse(localStorage.getItem('UserProfile'))
        localStorage.setItem("accountId",myProfile.accountId);
      }).catch(error => {
        this.setState({
          loading: false
        });  
      });
    } else {
      let myProfile = JSON.parse(localStorage.getItem('UserProfile'))
      localStorage.setItem("accountId",myProfile.accountId);
      this.setState({isAuthenticated: true, profile: myProfile})
    }
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }

    document.getElementById("minimizeSidebar").addEventListener("click", () => {
      this.setState({
        sidebarActive: !this.state.sidebarActive
      },()=>{
        if(this.state.sidebarActive){
          document.getElementsByClassName('logo-mini')[0].style.display = 'none';
        }else{
          document.getElementsByClassName('logo-mini')[0].style.display = 'block';

        }
      });
    })

    window.addEventListener('resize', () => {
      this.setState({
        isScreen: window.innerWidth < 1024
      });
  }, false);

  }

  getCustomMenus = () => {
    SettingsService.getCustomMenus()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          this.setState({
            customMenuLists: response.dashboardInfoDTOs
          }, () => {
            let tempOrderLists = this.state.customMenuLists;
            if (tempOrderLists !== null && tempOrderLists.length > 0) {
              this.state.tempArray = routes;
              let routeData = [];
              for(let [index, orderList] of tempOrderLists.entries()){
                let routeData_temp = {
                  path: orderList.menuName,
                  name: orderList.menuName,
                  icon: "fas fa-chart-line",
                  component: orderList.menuType === MenuNames.PowerBI ? PowerBI :  WidgetLayout,
                  layout: "/",
                  module: orderList.menuType === MenuNames.PowerBI ? "PowerBI" :  WidgetLayout,
                  display: "true"
                }
                routeData.push(routeData_temp)
                this.state.tempArray.push(routeData_temp)
                if(index === tempOrderLists.length -1){
                  this.setState({
                    tempArray: [...this.state.tempArray]
                  })
                }
              }
            }else{
              this.state.tempArray = routes;
              this.setState({
                tempArray: [...this.state.tempArray]
              })
            }
          })
        }else{
          this.state.tempArray = routes;
          this.setState({
            tempArray: [...this.state.tempArray]
          })
        }
      }).catch(err => {
        this.state.tempArray = routes;
        this.setState({
          tempArray: [...this.state.tempArray]
        })
      })
  }
  
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    // to stop the warning of calling setState of unmounted component
    var id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }
   // Clear all session while click logout button
   LogoutHandler = () =>{
    localStorage.clear();
    this.props.history.push('/auth/login-page');
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
 
  excludeFinalService = (finalArray, services) => {
    for (let i=0; i<finalArray.length; i++) {
      for (let service of services) {
        if (finalArray[i].name === service) {
          finalArray.splice(i, 1);
        }
      }
   }
   return finalArray;
  }

  includeFinalService = (finalArray, services) => {
    let newServices = [];
    for (let i=0; i<finalArray.length; i++) {
      for (let service of services) {
        if (finalArray[i].name === service) {
          newServices.push(finalArray[i]);
        }
      }
   }
   return newServices;
  } 

  handleMouseEvents = (event) => {
    event.preventDefault();
    if(!this.state.sidebarActive){
      this.setState(currentState => ({ sidebarHover: !currentState.sidebarHover }), () => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
          if(!this.state.sidebarHover){
            document.getElementById("img-big").style.display = "none";
            document.getElementById("emailspan").style.visibility = "hidden";
          }else{
            document.getElementById("img-big").style.display = "block";
            document.getElementById("emailspan").style.visibility = "visible";  
          }

        }
      });
    }
  }

  
  lastpageHistory = (name) => {
    localStorage.setItem("lastPageHistory", name)
    let customMenuLists = this.state.customMenuLists;
    let menuName = name.slice(1); // remove slash before menuname
    if(customMenuLists.filter(item => item.menuName === menuName).length > 0){
      this.getWidgetsByMenuName(menuName)
    }else{
      if(localStorage.getItem("dashboardId") !== null){
        localStorage.removeItem("dashboardId");
      }
    }
  }

  getWidgetsByMenuName = (name) => {
    SettingsService.getDashboardMenuName(name)
      .then((response) => {
        if (response.status === APIRESPONSE.SUCCESS && response.dashboardInfoDTOs !== null && response.dashboardInfoDTOs.length > 0) {
          localStorage.setItem("dashboardId", response.dashboardInfoDTOs[0].id)
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      })
  }


  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes) => {
    var finalArray = routes;
    let orderMenuList = [];
    if (localStorage.getItem("menuOrder") !== null) {
      orderMenuList = JSON.parse(localStorage.getItem("menuOrder"));
    }
    if(localStorage.getItem("role") === "TENANT_ADMIN"){
      let tempMenuList = tenantExclude;
      finalArray = this.excludeFinalService(finalArray, tempMenuList)
    }
    else if(localStorage.getItem("role") === "PLATFORM_ADMIN"){
      finalArray = this.includeFinalService(
        finalArray, platformAdminInclude)   //  Accounts and Cloud menus are showing for Platform admin
    }
    else if(localStorage.getItem("role") === "GENERAL_USER"){
      let tempMenuList = generalUserInclude;
      finalArray = this.includeFinalService(
        finalArray, tempMenuList)  // Showing only as in the list of array
    }
    else if(localStorage.getItem("role") === "DEVELOPER"){
      let tempMenuList = tenantExclude;
        tempMenuList.push("Settings");
      this.excludeFinalService(finalArray, tempMenuList)
   }
   else if(localStorage.getItem("role") === "TENANT_MANAGEMENT"){
    let tempMenuList = tenantExclude;
        tempMenuList.push("Settings");
    this.excludeFinalService(finalArray, tempMenuList)
 }
    return finalArray.map((prop, key) => {
      if(prop.name === "Admin"){
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          (localStorage.getItem("role")==="TENANT_ADMIN" || 
          localStorage.getItem("role")==="PLATFORM_ADMIN" || 
          localStorage.getItem("role")==="TENANT_MANAGEMENT")&& <li
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="# "
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                <div style={styles.submenumini}>
                 <span className="sidebar-mini-icon" >{prop.icon}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                  </div>
                </>
              )}
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      if(prop.name === "Billing"){
        var st1 = {};
        st1[prop["state"]] = !this.state[prop.state];
        return (
          (localStorage.getItem("role") === "TENANT_ADMIN" || 
          localStorage.getItem("role") === "PLATFORM_ADMIN" || 
          localStorage.getItem("role") === "TENANT_MANAGEMENT") && <li
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={e => {
                e.preventDefault();
                this.setState(st1);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                <div style={styles.submenumini}>
                  <span className="sidebar-mini-icon" >{prop.icon}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                  </div>
                </>
              )}
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      if(prop.display === "none"){
        return (
          <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
            <NavLink to={prop.layout + prop.path} activeclassname="" 
             style={styles.displaynone}>
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>{prop.name}</p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">{prop.name}</span>
                </>
              )}
            </NavLink>
          </li>
        );
      }
      if(prop.name === "Clusters"){
        let clusterFlag = JSON.parse(localStorage.getItem('UserProfile'));
        let finalFlag = clusterFlag!=null?clusterFlag.clusterRequired:false;
       
        return (
          localStorage.getItem("role")==="DEVELOPER" && finalFlag===true &&<li className={this.activeRoute(prop.layout + prop.path)} key={key}>
            <NavLink to={prop.layout + prop.path} activeclassname="">
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>{prop.name}</p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">{prop.name}</span>
                </>
              )}
            </NavLink>
          </li>
        );
      }
      if (prop.collapse) {
        
        var st2 = {};
        st2[prop["state"]] = !this.state[prop.state];
        return (
          <li
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="# "
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={e => {
                e.preventDefault();
                this.setState(st2);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <div style={styles.submenumini}>
                  <span className="sidebar-mini-icon">{prop.icon}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                  </div>
                </>
              )}
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      return (
        <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
 
          <NavLink to={prop.layout + prop.path} activeclassname="" onClick={e => this.lastpageHistory(prop.layout + prop.path)} >
            {prop.icon !== undefined ? (
              <>
                <i className={prop.name === MenuNames.PowerBI ? "fas fa-tachometer-alt" : prop.icon} />
                <p>{prop.name === MenuNames.PowerBI ? "Dashboard" : prop.name}</p>
              </>
            ) : (
              <>
                <div style={styles.submenumini}>
                <span className="sidebar-mini-icon">{prop.icon}</span>
                <span className="sidebar-normal">{prop.name}</span>
                </div>
              </>
            )}
          </NavLink> 
         
          {/* {prop.name === "Model Space" && (localStorage.getItem("role") === "TENANT_ADMIN" || localStorage.getItem("role") === "PLATFORM_ADMIN" || localStorage.getItem("role") === "DEVELOPER")&&<NavLink to={prop.layout + prop.path} activeclassname="">
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <div style={styles.submenumini}>
                <span className="sidebar-mini-icon">{prop.icon}</span>
                <span className="sidebar-normal">{prop.name}</span>
                </div>
              </>
            )}
          </NavLink>} */}
          {(prop.name=="Notebook"&& (localStorage.getItem("role")=="TENANT_ADMIN" || localStorage.getItem("role")=="DEVELOPER")) && <a href={this.state.tenantNote} target="_blank" activeclassname="">
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <div style={styles.submenumini}>
                <span className="sidebar-mini-icon">{prop.icon}</span>
                <span className="sidebar-normal">{prop.name}</span>
                </div>
              </>
            )}
          </a>}
        </li>
      );
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return window.location.href.indexOf(routeName) > -1 ? "active" : "";
  };
  render() {
    return (
      <>
        <div className="sidebar" 
         onMouseOverCapture={this.handleMouseEvents} onMouseOutCapture={this.handleMouseEvents} data-color={this.props.backgroundColor}>
          <div className="logo">
            <a
              href="https://decisionfacts.ai/"
              className="simple-text logo-mini logofit"
              target="_blank"
              rel="noreferrer"
            >
              <div className="logo-img">
                <img src={localStorage.getItem("accountLogo") !== null && localStorage.getItem("accountLogo") !== "null" ? localStorage.getItem("accountLogo") : logo} 
                alt="decisionforce" className="logoavatar avatar-sm rounded-circle fit-image"/>
              </div>
            </a>
            <a
              href="https://decisionfacts.ai/"
              className="simple-text logo-normal"
              target="_blank"
              rel="noreferrer"
            >
              <img id ="img-big" src={localStorage.getItem("accountLogo") !== null && localStorage.getItem("accountLogo") !== "null" ? localStorage.getItem("accountLogo") : logo}
                alt="decisionforce" className={ `${this.state.sidebarHover ? "logoavatar-fullview avatar-sm fit-image" : ""} ${this.state.isScreen ? "logoavatar-fullview avatar-sm fit-image" : ""}`}  />
              <span id="emailspan" title ={localStorage.getItem("accountName") !== null && localStorage.getItem("accountName") !== "null" ? localStorage.getItem("accountName") : "DecisionFacts"}
               className={this.state.sidebarHover ? "df-text-white text-uppercase" : "df-text-white text-uppercase" }>{localStorage.getItem("accountName") !== null && localStorage.getItem("accountName") !== "null" ? localStorage.getItem("accountName") : "DecisionFacts"}</span>
            </a>
            <div className="navbar-minimize">
              <Button
                outline
                className="btn-round btn-icon"
                color="neutral"
                id="minimizeSidebar"
                onClick={() => this.props.minimizeSidebar()}
              >
                <i className="now-ui-icons text_align-center visible-on-sidebar-regular" />
                <i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini" />
              </Button>
            </div>
          </div>

          <div className="sidebar-wrapper" ref={this.sidebar}>
            <Nav>{this.createLinks(this.state.tempArray)}</Nav>
          </div>
        </div>
      </>
    );
  }
}

Sidebar.defaultProps = {
  routes: [],
  showNotification: false,
  backgroundColor: "navyblue",
  minimizeSidebar: () => {}
};

Sidebar.propTypes = {
  // links that are rendered
  routes: PropTypes.arrayOf(PropTypes.object),
  // if you want to show a notification when switching between mini sidebar and normal
  showNotification: PropTypes.bool,
  // background color for the component
  backgroundColor: PropTypes.oneOf([
    "blue",
    "yellow",
    "green",
    "orange",
    "red",
    "navyblue"
  ]),
  // function that is called upon pressing the button near the logo
  minimizeSidebar: PropTypes.func
};

export default Sidebar;
